import React, { useCallback, useState } from 'react';
import { Box, Button } from '@mui/material';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import AgentPanel from './AgentPanel';
import { useAgent } from '../hooks/useAgent';

export default function AgentFloat() {
  const [isOpen, setIsOpen] = useState(false);
  const agent = useAgent();

  const handleOpen = useCallback(() => setIsOpen(true), []);
  const handleClose = useCallback(() => setIsOpen(false), []);

  return (
    <>
      {!isOpen && (
        <Button
          color="inherit"
          onClick={handleOpen}
          aria-label="エージェントを開く"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textTransform: 'none',
            lineHeight: 1.2,
            minWidth: 'auto',
            py: 0.5,
            px: 1,
          }}
        >
          <SmartToyIcon />
          <Box component="span" sx={{ fontSize: '0.6rem', mt: 0.2, whiteSpace: 'nowrap' }}>
            エージェント
          </Box>
        </Button>
      )}

      {isOpen && <AgentPanel agent={agent} onClose={handleClose} />}
    </>
  );
}
